/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import './AuthButton.scss';

const AuthButton = ({className = '', children = undefined, ...btnProps}) => (
  <Button className={`auth-btn ${className}`} {...btnProps}>{children}</Button>
);

const { string, node } = PropTypes;

AuthButton.propTypes = {
  children: node,
  className: string,
};

export default AuthButton;
